import {
  ConfirmModalArgs,
  useConfirmModal,
} from '@/components/ConfirmationModal';
import { useTranslation } from '@/i18n';
import { useMemo } from 'react';

export const useConfirmCancelReordering = () => {
  const { t } = useTranslation();
  const args: ConfirmModalArgs = useMemo(
    () => ({
      title: t('transaction_items.confirm.cancel_reordering.title'),
      body: t('transaction_items.confirm.cancel_reordering.message'),
      cancelButtonProps: {
        isTertiary: true,
        children: t(
          'transaction_items.confirm.cancel_reordering.button.return'
        ),
        testId: 'transaction_items.confirm.cancel_reordering.button.return',
      },
      okButtonProps: {
        isSecondary: true,
        color: 'danger',
        children: t(
          'transaction_items.confirm.cancel_reordering.button.discard'
        ),
        testId: 'transaction_items.confirm.cancel_reordering.button.discard',
      },
    }),
    [t]
  );
  return useConfirmModal(args);
};
